import httpService from "./http-service";

export default {
  updateEnrollmentDetail(enrollmentTermUuid, uuid, payload) {
    return httpService.put(
      `enrollment-terms/${enrollmentTermUuid}/enrollment-details/${uuid}`,
      payload
    );
  },
  getTranscript(enrollmentYear) {
    return httpService.get(
      `student/enrollment-year/${enrollmentYear}/getTranscript`,
      { responseType: "arraybuffer" }
    );
  },
  getCrmStudentData(id) {
    return httpService.get(`student/student-information/${id}`);
  },
  getCrmStudentsList() {
    return httpService.get(`student/students-list`);
  },
  updateStudent(id, payload) {
    return httpService.put(`student/student-information/${id}`, payload);
  },
};
